import React from "react";
import "./Produk.scss";
import data from "./data.json";
import Card from "../../Component/Card Viola/cardviola";
import Elmimages from "../../Media/Tipe 8/Elm";
import Birchimages from "../../Media/Tipe 6/Birch";
import Banyanimages from "../../Media/Tipe 10/Banyan";

const imageMap = {
  Elmimages,
  Birchimages,
  Banyanimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="residential" className="produk">
      <h1>Cluster Pinehill</h1>
      <h2>Luxury Homes with Mountain Views</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
